import styles from './Filter.module.css';

import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Icon from '@mui/material/Icon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Search from '@mui/icons-material/Search';

import { useAuth } from '../../AuthContext';

export const Filter = ({ filters, onFilterChange, onClearFilters }) => {
    const [ isExpanded, setIsExpanded ] = React.useState(false);

    const { claims } = useAuth();

    const toggleExpanded = () => setIsExpanded(!isExpanded);

    const handleInputChange = (field, value) => {
        onFilterChange({ ...filters, [ field ]: value });
    };

    const hasActiveFilters = filters.search || filters.showUnverifiedEmail || filters.showUnverifiedPhone || filters.showMissingNspNumber;

    return (
        <div className={ styles.filterContainer }>
            <div className={ styles.filterHeader } onClick={ toggleExpanded }>
                <span>
                    { hasActiveFilters && <span className={ styles.activeIndicator }>●&nbsp;</span> }
                    <Icon component={ Search } sx={ { mr: 1 } } />
                    <Typography>Search</Typography>
                </span>

                <span>
                    <Icon component={ isExpanded ? ExpandLess : ExpandMore } />
                </span>
            </div>

            <div className={ `${ styles.filterContent } ${ isExpanded ? styles.expanded : styles.collapsed }` }>
                <Stack direction="column" spacing={ 2 } alignItems="left" className={ styles.filterRow }>
                    <input
                        type="text"
                        placeholder="Search by name, email, phone, NSP, or role"
                        value={ filters.search }
                        onChange={ (e) => handleInputChange('search', e.target.value) }
                        className={ styles.searchInput }
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.showUnverifiedEmail || false }
                                onChange={ (e) => handleInputChange('showUnverifiedEmail', e.target.checked) }
                            />
                        }
                        label="Show Unverified Email"
                        sx={{ display: claims?.admin ? 'block' : 'none' }}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.showUnverifiedPhone || false }
                                onChange={ (e) => handleInputChange('showUnverifiedPhone', e.target.checked) }
                            />
                        }
                        label="Show Unverified Phone"
                        sx={{ display: claims?.admin ? 'block' : 'none' }}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.showMissingNspNumber || false }
                                onChange={ (e) => handleInputChange('showMissingNspNumber', e.target.checked) }
                            />
                        }
                        label="Show Missing NSP Number"
                        sx={{ display: claims?.admin ? 'block' : 'none' }}
                    />
                </Stack>

                { hasActiveFilters && (
                    <button
                        className={ styles.clearButton }
                        onClick={ onClearFilters }
                    >
                        Clear Filters
                    </button>
                ) }
            </div>
        </div>
    );
};